import { Stack, Title } from '@common/ui'
import { com } from '@eidu/web'
import { useSortedEntityTypes } from '../../io/useEntityTypes'
import useSemanticLinks from '../../io/useSemanticLinks'
import EntityTypesStack from '../../components/layout/EntityTypesStack'
import EntityTypeKind = com.eidu.entity.type.EntityTypeKind
import EntityType = com.eidu.entity.type.EntityType
import SemanticLink = com.eidu.entity.analytics.SemanticLink

type SemanticsPageContentProps = {
  entityTypes: readonly EntityType[]
  semanticLinks: readonly SemanticLink[]
}

const SemanticsPageContent = ({ entityTypes, semanticLinks }: SemanticsPageContentProps) => (
  <Stack gap="lg" p="lg">
    <Title order={2}>Semantics</Title>
    <EntityTypesStack kind={EntityTypeKind.Companion.School} entityTypes={entityTypes} semanticLinks={semanticLinks} />
    <EntityTypesStack kind={EntityTypeKind.Companion.User} entityTypes={entityTypes} semanticLinks={semanticLinks} />
  </Stack>
)

const SemanticsPage = () => {
  const entityTypes = useSortedEntityTypes() ?? []
  const { semanticLinks } = useSemanticLinks()

  return <SemanticsPageContent entityTypes={entityTypes} semanticLinks={semanticLinks ?? []} />
}

export default SemanticsPage

export { SemanticsPageContent }
